"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const applicationRoutingStackEnsureMaxLenghtNotExceeded = ({ maxRoutesOnStack, stack, }) => {
    if (stack.length <= maxRoutesOnStack) {
        return stack;
    }
    return stack.slice(1, maxRoutesOnStack + 1);
};
exports.default = applicationRoutingStackEnsureMaxLenghtNotExceeded;
